module.exports = __webpack_public_path__ + "img/yabanzhou.prt.54ad6dde.jpg";